// import React from 'react';
// import { Link } from 'react-router-dom';
// import Countdown from 'react-countdown';
// import i18n from '../../../i18n';
// import { BiddingModal } from '../../helpers/biddingModal';
// import { getLoggedUser } from '../../../state/user';
// import swal from 'sweetalert';
// import { VisitNow } from './visitNow';
// import { formatCurrency } from '../../../state/utils';

// const is_logged = localStorage.getItem('is_logged_in') ? true : false;
// const user = getLoggedUser();
// let lng = localStorage.getItem('I18N_LANGUAGE');

// export class AuctionRowGrouped extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       open_popup: false,
//       bid_count: 0,
//       now: () => {
//         let time = new Date().toLocaleTimeString('en-US', {
//           timeZone: 'Asia/Muscat',
//         });
//         let dt = new Date().toISOString('en-US').split('T')[0];
//         let newDt = dt + ' ' + time;
//         newDt = new Date(newDt.replace(/-/g, '/'));
//         return newDt;
//       },
//     };
//     this.closeModal = this.closeModal.bind(this);
//     this.updateRow = this.updateRow.bind(this);
//   }

//   renderer = ({ days, hours, minutes, seconds, completed }) => {
//     if (completed) {
//       return (
//         <span className="auction-countdown-badge auction-ended">
//           {this.props.auction.end_date_formatted}
//         </span>
//       );
//     } else {
//       let today = new Date();
//       let start_date = new Date(this.createDate(this.props.auction.start_date));
//       if (start_date.getTime() > today.getTime()) {
//         return (
//           <span className="auction-countdown-badge auction-not-started">
//             00 : 00 : 00 : 00
//           </span>
//         );
//       }

//       let warning = days === 0 && hours === 0 && minutes === 0 && seconds < 10 ? true : false;
//       return (
//         <span className={`auction-countdown-badge ${warning ? 'auction-warning' : 'auction-active'}`}>
//           {days}{i18n.t('D')} : {hours}{i18n.t('H')} : {minutes}{i18n.t('M')} : {seconds}{i18n.t('S')}
//         </span>
//       );
//     }
//   };

//   componentDidMount() {
//     this.setState({ bid_count: this.props.auction.bid_count });
//   }

//   closeModal() {
//     this.setState({ open_popup: false });
//   }

//   updateRow(data) {
//     this.setState({ bid_count: data });
//   }

//   createDate(dt) {
//     return dt ? new Date(dt.replace(/-/g, '/')) : null;
//   }

//   render() {
//     let key = this.props.keys;
//     let auction = this.props.auction;
//     let images = auction.images;
//     let img_src = process.env.PUBLIC_URL + '/assets/images/placeholder.jpg';
//     if (images.length > 0) {
//       img_src = images[0].image;
//     }

//     let now = this.state.now;
//     let aucEndDate = auction.end_date;
//     let auctionEndTime = new Date(this.createDate(aucEndDate)).getTime();

//     let visit_amount = this.props.visit_amount;
//     let group = this.props.group;

//     return (
//       <React.Fragment>
//         <style>{`
//           .modern-auction-card {
//             display: flex;
//             background: #ffffff;
//             border-radius: 20px;
//             overflow: hidden;
//             box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
//             margin-bottom: 20px;
//             transition: all 0.3s ease;
//             border: 1px solid #f1f5f9;
//             position: relative;
//           }

//           .modern-auction-card:hover {
//             box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
//             transform: translateY(-2px);
//           }

//           .auction-image-section {
//             flex: 0 0 300px;
//             position: relative;
//             overflow: hidden;
//             cursor: pointer;
//             background: #f8fafc;
//           }

//           .auction-image {
//             width: 100%;
//             height: 100%;
//             object-fit: cover;
//             transition: transform 0.4s ease;
//           }

//           .auction-image-section:hover .auction-image {
//             transform: scale(1.05);
//           }

//           .auction-status-badge {
//             position: absolute;
//             top: 16px;
//             left: 16px;
//             padding: 8px 16px;
//             border-radius: 25px;
//             font-size: 12px;
//             font-weight: 600;
//             text-transform: uppercase;
//             letter-spacing: 0.5px;
//             color: white;
//             z-index: 2;
//           }

//           .status-active {
//             background: linear-gradient(135deg, #10b981, #059669);
//             box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
//           }

//           .status-inactive {
//             background: linear-gradient(135deg, #6b7280, #4b5563);
//             box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);
//           }

//           .auction-overlay {
//             position: absolute;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
//             opacity: 0;
//             transition: opacity 0.3s ease;
//           }

//           .auction-image-section:hover .auction-overlay {
//             opacity: 1;
//           }

//           .auction-content-section {
//             flex: 1;
//             padding: 24px;
//             display: flex;
//             flex-direction: column;
//             justify-content: space-between;
//           }

//           .auction-header {
//             margin-bottom: 20px;
//           }

//           .auction-title {
//             font-size: 20px;
//             font-weight: 700;
//             color: #1e293b;
//             margin: 0 0 8px 0;
//             line-height: 1.3;
//             display: -webkit-box;
//             -webkit-line-clamp: 2;
//             -webkit-box-orient: vertical;
//             overflow: hidden;
//           }

//           .auction-lot-number {
//             font-size: 14px;
//             color: #64748b;
//             margin: 0;
//             font-family: 'Courier New', monospace;
//             font-weight: 500;
//           }

//           .auction-top-section {
//             display: flex;
//             justify-content: space-between;
//             align-items: flex-start;
//             margin-bottom: 20px;
//           }

//           .auction-rank-section {
//             text-align: right;
//           }

//           .auction-rank-label {
//             font-size: 14px;
//             color: #f59e0b;
//             font-weight: 600;
//             margin-bottom: 8px;
//             display: block;
//           }

//           .auction-details-btn {
//             background: linear-gradient(135deg, #06b6d4, #0891b2);
//             color: white;
//             border: none;
//             padding: 10px 20px;
//             border-radius: 12px;
//             font-size: 14px;
//             font-weight: 600;
//             cursor: pointer;
//             transition: all 0.3s ease;
//             box-shadow: 0 4px 12px rgba(6, 182, 212, 0.25);
//           }

//           .auction-details-btn:hover {
//             background: linear-gradient(135deg, #0891b2, #0e7490);
//             transform: translateY(-1px);
//             box-shadow: 0 6px 16px rgba(6, 182, 212, 0.35);
//           }

//           .auction-info-grid {
//             display: grid;
//             grid-template-columns: 1fr 1fr 1fr;
//             gap: 20px;
//             margin-bottom: 24px;
//             padding: 20px;
//             background: #f8fafc;
//             border-radius: 16px;
//             border: 1px solid #e2e8f0;
//           }

//           .auction-info-item {
//             text-align: center;
//           }

//           .auction-info-icon {
//             width: 24px;
//             height: 24px;
//             margin: 0 auto 8px;
//             display: block;
//             opacity: 0.7;
//           }

//           .auction-info-label {
//             font-size: 12px;
//             color: #64748b;
//             text-transform: uppercase;
//             letter-spacing: 0.5px;
//             font-weight: 600;
//             margin-bottom: 4px;
//           }

//           .auction-info-value {
//             font-size: 14px;
//             color: #1e293b;
//             font-weight: 600;
//           }

//           .auction-countdown-badge {
//             display: inline-block;
//             padding: 6px 12px;
//             border-radius: 8px;
//             font-size: 13px;
//             font-weight: 600;
//             font-family: 'Courier New', monospace;
//           }

//           .auction-active {
//             background: #dbeafe;
//             color: #1d4ed8;
//             border: 1px solid #3b82f6;
//           }

//           .auction-warning {
//             background: #fee2e2;
//             color: #dc2626;
//             border: 1px solid #ef4444;
//             animation: pulse 1s infinite;
//           }

//           .auction-ended {
//             background: #f3f4f6;
//             color: #6b7280;
//             border: 1px solid #9ca3af;
//           }

//           .auction-not-started {
//             background: #fef3c7;
//             color: #d97706;
//             border: 1px solid #f59e0b;
//           }

//           @keyframes pulse {
//             0%, 100% { opacity: 1; }
//             50% { opacity: 0.7; }
//           }

//           .auction-bottom-section {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           .auction-pricing {
//             flex: 1;
//           }

//           .auction-current-amount {
//             font-size: 18px;
//             font-weight: 700;
//             color: #1e293b;
//             margin-bottom: 4px;
//           }

//           .auction-start-price {
//             font-size: 14px;
//             color: #64748b;
//           }

//           .auction-visit-amount {
//             background: linear-gradient(135deg, #fee2e2, #fecaca);
//             border: 1px solid #f87171;
//             border-radius: 12px;
//             padding: 12px 16px;
//             margin-bottom: 20px;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           .auction-visit-text {
//             font-size: 14px;
//             color: #dc2626;
//             font-weight: 600;
//           }

//           .auction-visit-btn {
//             background: #dc2626;
//             color: white;
//             border: none;
//             padding: 6px 12px;
//             border-radius: 8px;
//             font-size: 12px;
//             font-weight: 600;
//             cursor: pointer;
//             transition: all 0.2s ease;
//           }

//           .auction-visit-btn:hover {
//             background: #b91c1c;
//             transform: translateY(-1px);
//           }

//           .auction-bid-btn {
//             background: linear-gradient(135deg, #ef4444, #dc2626);
//             color: white;
//             border: none;
//             padding: 14px 28px;
//             border-radius: 14px;
//             font-size: 15px;
//             font-weight: 700;
//             cursor: pointer;
//             transition: all 0.3s ease;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//             text-decoration: none;
//             box-shadow: 0 4px 16px rgba(239, 68, 68, 0.3);
//             text-transform: uppercase;
//             letter-spacing: 0.5px;
//           }

//           .auction-bid-btn:hover {
//             background: linear-gradient(135deg, #dc2626, #b91c1c);
//             transform: translateY(-2px);
//             box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
//           }

//           .auction-bid-btn:disabled {
//             background: #e5e7eb;
//             color: #9ca3af;
//             cursor: not-allowed;
//             transform: none;
//             box-shadow: none;
//           }

//           .auction-bid-btn:disabled:hover {
//             background: #e5e7eb;
//             transform: none;
//             box-shadow: none;
//           }

//           .auction-bid-icon {
//             width: 16px;
//             height: 16px;
//           }

//           /* Mobile Responsiveness */
//           @media (max-width: 768px) {
//             .modern-auction-card {
//               flex-direction: column;
//               border-radius: 16px;
//             }

//             .auction-image-section {
//               flex: none;
//               height: 200px;
//             }

//             .auction-content-section {
//               padding: 20px;
//             }

//             .auction-info-grid {
//               grid-template-columns: 1fr;
//               gap: 16px;
//               padding: 16px;
//             }

//             .auction-top-section {
//               flex-direction: column;
//               gap: 16px;
//             }

//             .auction-rank-section {
//               text-align: left;
//             }

//             .auction-bottom-section {
//               flex-direction: column;
//               gap: 16px;
//               align-items: stretch;
//             }

//             .auction-title {
//               font-size: 18px;
//             }

//             .auction-current-amount {
//               font-size: 16px;
//             }
//           }

//           /* RTL Support */
//           [dir="rtl"] .auction-content-section {
//             text-align: right;
//           }

//           [dir="rtl"] .auction-top-section {
//             flex-direction: row-reverse;
//           }

//           [dir="rtl"] .auction-rank-section {
//             text-align: left;
//           }

//           /* Hover Effects for Interactive Elements */
//           .auction-info-item:hover {
//             transform: translateY(-2px);
//             transition: transform 0.2s ease;
//           }

//           .auction-title:hover {
//             color: #0f172a;
//             transition: color 0.2s ease;
//           }

//           /* Loading State */
//           .auction-loading {
//             opacity: 0.7;
//             pointer-events: none;
//           }

//           /* Focus States for Accessibility */
//           .auction-details-btn:focus,
//           .auction-bid-btn:focus {
//             outline: 2px solid #3b82f6;
//             outline-offset: 2px;
//           }
//         `}</style>

//         <div className="modern-auction-card">
//           {/* Image Section */}
//           <div
//             className="auction-image-section"
//             onClick={() => {
//               this.props.getImagePopup(true, images);
//             }}
//           >
//             <img src={img_src} alt="Auction" className="auction-image" />
//             <div className="auction-overlay"></div>

//             {/* Status Badge */}
//             <div className={`auction-status-badge ${auction.status === 'A' ? 'status-active' : 'status-inactive'}`}>
//               {auction.status === 'A' ? 'Auction' : 'Closed'}
//             </div>
//           </div>

//           {/* Content Section */}
//           <div className="auction-content-section">
//             {/* Header */}
//             <div className="auction-header">
//               <h3 className="auction-title">
//                 {lng === 'ar' ? auction.title_ar : auction.title}
//               </h3>
//               <p className="auction-lot-number">
//                 {i18n.t('lot')} # : {auction.auction_number}
//               </p>
//             </div>

//             {/* Top Section with Rank and Details */}
//             <div className="auction-top-section">
//               <div className="auction-rank-section">
//                 <span className="auction-rank-label">
//                   {i18n.t('my_rank')} : {auction.my_rank || 'N/A'}
//                 </span>
//                 <button
//                   className="auction-details-btn"
//                   onClick={() => {
//                     if (is_logged && !user.is_staff && auction.is_staff_auction) {
//                       swal(i18n.t('un_authorized'), i18n.t('non_staff_popup'), 'warning');
//                       return;
//                     }
//                     window.location.href = '/auction-details/' + auction.id;
//                   }}
//                 >
//                   {i18n.t('details')}
//                 </button>
//               </div>
//             </div>

//             {/* Info Grid */}
//             <div className="auction-info-grid">
//               <div className="auction-info-item">
//                 <img
//                   src={process.env.PUBLIC_URL + '/assets/images/bx_time.png'}
//                   className="auction-info-icon"
//                   alt="clock"
//                 />
//                 <div className="auction-info-value">
//                   {auctionEndTime && (
//                     <Countdown
//                       date={auctionEndTime}
//                       renderer={this.renderer}
//                       now={now}
//                       onComplete={() => {
//                         this.setState({ show_end_time: true });
//                       }}
//                     />
//                   )}
//                 </div>
//               </div>

//               <div className="auction-info-item">
//                 <img
//                   src={process.env.PUBLIC_URL + '/assets/images/mingcute_location-line.png'}
//                   className="auction-info-icon"
//                   alt="location"
//                 />
//                 <div className="auction-info-label">{i18n.t('location')} :</div>
//                 <div className="auction-info-value">
//                   {lng === 'ar' && auction.location_ar ? auction.location_ar : auction.location}
//                 </div>
//               </div>

//               <div className="auction-info-item">
//                 <img
//                   src={process.env.PUBLIC_URL + '/assets/images/ri_auction-line.png'}
//                   className="auction-info-icon"
//                   alt="bid"
//                 />
//                 <div className="auction-info-label">{i18n.t('bid_count')} :</div>
//                 <div className="auction-info-value">{this.state.bid_count}</div>
//               </div>
//             </div>

//             {/* Visit Amount */}
//             {!isNaN(visit_amount) && visit_amount > 0 && (
//               <div className="auction-visit-amount">
//                 <span className="auction-visit-text">
//                   {i18n.t('visit_amount')}: {formatCurrency(visit_amount)} {i18n.t('sar')}
//                 </span>
//                 {!group.is_visit_active && (
//                   <VisitNow
//                     amount={visit_amount}
//                     type="sitevisit"
//                     id={null}
//                     gid={group.group}
//                     is_group={true}
//                   />
//                 )}
//               </div>
//             )}

//             {/* Bottom Section */}
//             <div className="auction-bottom-section">
//               <div className="auction-pricing">
//                 <div className="auction-current-amount">
//                   {i18n.t('current_amount')} : {lng === 'en' ? i18n.t('sar') : ''} {formatCurrency(auction.current_amount)} {lng === 'ar' ? i18n.t('sar') : ''}
//                 </div>
//                 <div className="auction-start-price">
//                   {i18n.t('start_price')} : {lng === 'en' ? i18n.t('sar') : ''} {formatCurrency(auction.start_amount, lng)} {lng === 'ar' ? i18n.t('sar') : ''}
//                 </div>
//               </div>

//               {/* Bid Button */}
//               {auction.status !== 'A' && (
//                 <button className="auction-bid-btn" disabled={true}>
//                   <img
//                     src={process.env.PUBLIC_URL + '/assets/images/active-auctions-icon.png'}
//                     className="auction-bid-icon"
//                     alt="bid"
//                   />
//                   {i18n.t('bid_now')}
//                 </button>
//               )}

//               {auction.status === 'A' && auction.is_enrolled && (
//                 <button
//                   className="auction-bid-btn"
//                   onClick={() => {
//                     if (is_logged && !user.is_staff && auction.is_staff_auction) {
//                       swal(i18n.t('un_authorized'), i18n.t('non_staff_popup'), 'warning');
//                       return;
//                     }
//                     this.setState({
//                       open_popup: true,
//                     });
//                   }}
//                 >
//                   <img
//                     src={process.env.PUBLIC_URL + '/assets/images/active-auctions-icon.png'}
//                     className="auction-bid-icon"
//                     alt="bid"
//                   />
//                   {i18n.t('bid_now')}
//                 </button>
//               )}

//               {auction.status === 'A' && !auction.is_enrolled && (
//                 <Link to={is_logged ? '/enroll/' + auction.id : '/login'} className="auction-bid-btn">
//                   <img
//                     src={process.env.PUBLIC_URL + '/assets/images/active-auctions-icon.png'}
//                     className="auction-bid-icon"
//                     alt="bid"
//                   />
//                   {i18n.t('bid_now')}
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>

//         <BiddingModal
//           open_popup={this.state.open_popup}
//           closeModal={this.closeModal}
//           auction={auction}
//           lng={lng}
//           key={key}
//           updateRow={this.updateRow}
//         />
//       </React.Fragment>
//     );
//   }
// }



import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { BiddingModal } from "../../helpers/biddingModal";
import { toggleLike, toggleWishlist } from "../../../models/auctions";
import { AuctionShare } from "./auctionShare";
import swal from "sweetalert";
import { getLoggedUser } from "../../../state/user";
import { formatCurrency } from "../../../state/utils";
import { VisitNow } from "./visitNow";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";

let is_logged = localStorage.getItem("is_logged_in") ? true : false;
const user = getLoggedUser();

const FinishBid = () => (
  <div className="bid-started">
    <i className="fa fa-clock-o me-2"></i>
    {i18n.t("auction_started")}
  </div>
);

const rendererEnds = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <FinishBid />;
  } else {
    return (
      <div className="countdown-container ends-timer">
        <div className="countdown-header">
          <i className="fa fa-hourglass-half me-2"></i>
          {i18n.t("ends_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">{i18n.t("lbl_day")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">{i18n.t("lbl_hour")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">{i18n.t("lbl_minute")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">{i18n.t("lbl_second")}</span>
          </div>
        </div>
      </div>
    );
  }
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return "";
  } else {
    return (
      <div className="countdown-container starts-timer">
        <div className="countdown-header">
          <i className="fa fa-play-circle me-2"></i>
          {i18n.t("starts_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <p className="countdown-number">{days}</p>
            <p className="countdown-label">{i18n.t("lbl_day")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{hours}</p>
            <p className="countdown-label">{i18n.t("lbl_hour")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{minutes}</p>
            <p className="countdown-label">{i18n.t("lbl_minute")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{seconds}</p>
            <p className="countdown-label">{i18n.t("lbl_second")}</p>
          </div>
        </div>
      </div>
    );
  }
};

export class AuctionRowGrouped extends React.Component {
  constructor() {
    super();
    this.state = {
      open_popup: false,
      wishlist: false,
      like: false,
      is_active_light_box: false,
      bidTimeStopped: false,
      now: () => {
        let time = new Date().toLocaleTimeString("en-US", {
          timeZone: "Asia/Muscat",
        });
        let dt = new Date().toISOString("en-US").split("T")[0];
        let newDt = dt + " " + time;
        newDt = new Date(newDt.replace(/-/g, "/"));
        return newDt;
      },
    };
    this.closeModal = this.closeModal.bind(this);
    this.addWishList = this.addWishList.bind(this);
    this.addLike = this.addLike.bind(this);
    this.incrementTime = this.incrementTime.bind(this);
  }

  componentDidMount() {
    this.setState({ like: this.props.auction.auction_liked });
    this.setState({ wishlist: this.props.auction.auction_wishlisted });
    if (this.props.auction) {
      setInterval(this.incrementTime, 1000);
    }
  }

  incrementTime() {
    let { auction } = this.props;
    if (!auction) {
      console.error("auction is undefined in props");
      return;
    }
    let dt = new Date(auction.server_time);
    dt.setSeconds(dt.getSeconds() + 1);
    auction.server_time = dt;
    this.setState({ auction });
  }

  closeModal() {
    this.setState({ open_popup: false });
  }

  async addWishList(wishlist) {
    if (is_logged) {
      const response = await toggleWishlist({
        auction_id: this.props.auctionId,
        wishlist,
      });
      if (response) {
        this.setState({ wishlist: wishlist });
      }
    }
  }

  async addLike(like) {
    if (is_logged) {
      const response = await toggleLike({
        auction_id: this.props.auctionId,
        like,
      });
      if (response) {
        this.setState({ like: like });
      }
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, "/")) : null;
  }

  getStatusBadgeClass(status) {
    const statusClasses = {
      E: "status-expired",
      F: "status-featured",
      A: "status-active",
      U: "status-upcoming",
    };
    return `status-badge ${statusClasses[status] || "status-active"}`;
  }

  render() {
    let current_lng = localStorage.getItem("I18N_LANGUAGE");
    let auction = this.props.auction;
    let images = this.props.images;
    let img_src = process.env.PUBLIC_URL + "/assets/images/placeholder.jpg";

    if (images.length > 0) {
      img_src = images[0].image;
    }

    let key = this.props.key;

    let amount_label = "";
    if (this.props.type === "upcoming") {
      amount_label = i18n.t("start_bid_amount");
    } else if (this.props.type === "previous") {
      amount_label = i18n.t("last_bid_amount");
    } else {
      amount_label = i18n.t("current_amount");
    }

    let startDateAr = auction.start_date_ar;
    let endDateAr = auction.end_date_ar;

    let statusAr = auction.status_label;
    let disp_status = "";
    let statusClass = this.getStatusBadgeClass(statusAr?.status);

    if (statusAr && statusAr["status"]) {
      disp_status = current_lng === "ar" ? statusAr["ar"] : statusAr["en"];
    }

    let endTime = new Date(this.createDate(auction.start_date)).getTime();
    let aucEndTime = new Date(this.createDate(auction.end_date)).getTime();

    let end_time = endDateAr && endDateAr["time"] ? endDateAr["time"] : "";
    end_time = end_time.replace("PM", i18n.t("PM"));
    end_time = end_time.replace("AM", i18n.t("AM"));

    let start_time = startDateAr && startDateAr["time"] ? startDateAr["time"] : "";
    start_time = start_time.replace("PM", i18n.t("PM"));
    start_time = start_time.replace("AM", i18n.t("AM"));

    let guarantee_amount = Number(auction.guarantee_amount);
    let orgImage = "";
    if (
      auction &&
      auction.organizationDetails &&
      auction.organizationDetails.file_organization_image_full
    ) {
      orgImage = auction.organizationDetails.file_organization_image_full;
    }

    const currentDate = new Date();
    const auctionStartDate = new Date(auction.start_date);
    let can_show_end_clock = true;

    if (auctionStartDate > currentDate) {
      can_show_end_clock = false;
    }

    return (
      <React.Fragment key={this.props.key}>
        <style jsx>{`
           .row.sidebar-split .col-6 {
            position: relative;
            padding: 0.5rem 1rem;
            }

           .row.sidebar-split .col-6:first-child {
              border-right: 1px solid #e2e8f0; /* subtle gray line */
            }`}
        </style>

        <div className="col-12 mb-3">
          <div className="horizontal-auction-card">
            {/* Left Section - Image */}
            <div className="card-image-section">
              <img
                src={img_src}
                className="auction-image-horizontal"
                alt=""
                onClick={() => {
                  this.props.getImagePopup(true, images);
                }}
              />

              {/* Status Badge */}
              <span className={`${statusClass} horizontal-status-badge`}>
                {disp_status}
              </span>

              {/* Organization Badge */}
              {orgImage && (
                <img src={orgImage} alt="Organization" className="org-badge-horizontal" />
              )}
            </div>

            {/* Right Section - Content */}
            <div className="card-content-section">
              {/* Header Section */}

              {/* <div className="card-header-horizontal">
                <h3 className="auction-title-horizontal">
                  {current_lng === "ar" ? this.props.title_ar : this.props.title}
                </h3>

              
                <div className="interaction-bar-horizontal">
                  <button className="interaction-btn-horizontal">
                    <i className="fa fa-eye"></i> {this.props.total_views}
                  </button>
                  <button
                    className={`interaction-btn-horizontal ${this.state.wishlist ? 'active' : ''}`}
                    onClick={(event) => {
                      this.addWishList(!this.state.wishlist);
                    }}
                  >
                    <i className={this.state.wishlist ? "fa fa-heart" : "fa fa-heart-o"}></i>
                  </button>
                  <button
                    className={`interaction-btn-horizontal ${this.state.like ? 'active' : ''}`}
                    onClick={(event) => {
                      this.addLike(!this.state.like);
                    }}
                  >
                    <i className={this.state.like ? "fa fa-thumbs-up" : "fa fa-thumbs-o-up"}></i>
                  </button>
                  <button className="interaction-btn-horizontal">
                    {i18n.t("bid_counr")} #{auction.bid_count}
                  </button>
                </div>
              </div> */}

              {/* Main Content Grid */}
              <div className="content-grid-horizontal">
                <div className="row">
                  <div className="col-12 col-md-8">
                    <div className="details-column">
                      {/* Lot Information */}
                      <div className="lot-info">
                        <h3 className="auction-title-horizontal">
                          {current_lng === "ar" ? this.props.title_ar : this.props.title}
                        </h3>


                      </div>

                        <div >

                          <div className="lot-label">Lot :  #MZADSA{auction.id}</div>
                          </div>


                      {/* Date and Location 
                      <div className="date-location-info">

                        <div className="date-time">
                          <i className="fa fa-calendar me-2"></i>
                          {startDateAr && startDateAr["date"] ? startDateAr["date"] : ""} {start_time}
                        </div>

                        <div className="date-time">
                          <i className="fa fa-calendar me-2"></i>
                          {endDateAr && endDateAr["date"] ? endDateAr["date"] : ""} {end_time}
                        </div>*/}

                        {/* <div className="interaction-bar-modern pt-2">

                          <button className="interaction-btn-modern">
                            <i className="fa fa-eye"></i> {this.props.total_views}
                          </button>
                          <button
                            className={`interaction-btn-modern ${this.state.wishlist ? 'active' : ''}`}
                            onClick={(event) => {
                              this.addWishList(!this.state.wishlist);
                            }}
                          >
                            <i className={this.state.wishlist ? "fa fa-heart" : "fa fa-heart-o"}></i>
                          </button>
                          <button
                            className={`interaction-btn-modern ${this.state.like ? 'active' : ''}`}
                            onClick={(event) => {
                              this.addLike(!this.state.like);
                            }}
                          >
                            <i className={this.state.like ? "fa fa-thumbs-up" : "fa fa-thumbs-o-up"}></i>
                          </button>

                          <button className="interaction-btn-modern">
                            <i className="fa fa-calendar"></i> {auction.days_remaining}
                          </button>
                        </div> */}

                      {/* </div>  */}

                      
                       

                      {/* Bid Time Status */}
                      {/* {(auction.is_bid_time_ends || auction.status !== "A") && (
                        <div className="bid-ended">
                          <i className="fa fa-times-circle me-2"></i>
                          {i18n.t("bid_time_ends")}
                        </div>
                      )} */}

                      {/* Countdown Timers */}
                      {/* {auction.status === "A" &&
                        !auction.is_bid_time_ends &&
                        auction.end_date && (
                          <Countdown
                            date={endTime}
                            renderer={renderer}
                            onComplete={() => {
                              this.setState({ bidTimeStopped: true });
                            }}
                            now={() => new Date(auction.server_time)}
                          />
                        )} */}

                      {/* {auction.status === "A" &&
                        !auction.is_bid_time_ends &&
                        auction.end_date &&
                        can_show_end_clock && (
                          <Countdown
                            date={aucEndTime}
                            renderer={rendererEnds}
                            onComplete={() => {
                              this.setState({ bidTimeStopped: true });
                            }}
                            now={() => new Date(auction.server_time)}
                          />
                        )} */}


                      <div className="row sidebar-split">
                        <div className="col-6 d-flex align-items-center">
                          <i className="fa fa-calendar me-2"></i>
                          <span>
                            {endDateAr && endDateAr["date"] ? endDateAr["date"] : ""} {end_time}
                          </span>
                        </div>

                        <div className="col-6 d-flex align-items-center">
                          <a
                            target="_blank"
                            href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}>
                            <i className="fa fa-map-marker me-2 text-black"></i>
                            <span className="text-black">{auction.location}</span>
                          </a>
                        </div>
                      </div>


                      <div className="action-buttons-modern">
                        <Link
                          to={"/auction-details/" + this.props.auctionId}
                          className="btn btn-primary-custom flex-fill"
                        >
                          <i className="fa fa-info-circle me-2"></i>
                          {i18n.t("view_details")}
                        </Link>

                        {this.props.can_bid && auction.is_enrolled && (
                          <button
                            className="btn btn-warning-custom flex-fill"
                            onClick={() => {
                              if (
                                is_logged &&
                                !user.is_staff &&
                                auction.is_staff_auction
                              ) {
                                swal(
                                  i18n.t("un_authorized"),
                                  i18n.t("non_staff_popup"),
                                  "warning"
                                );
                                return;
                              }
                              this.setState({ open_popup: true });
                            }}
                          >
                            <i className="fa fa-gavel me-2"></i>
                            {i18n.t("bid_now")}
                          </button>
                        )}

                        {auction.status === "A" && !auction.is_enrolled && (
                          <Link
                            to={!is_logged ? "/login" : "/enroll/" + auction.id}
                            className="btn btn-primary-custom flex-fill"
                          >
                            <i className="fa fa-user-plus me-2"></i>
                            {i18n.t("enroll")}
                          </Link>
                        )}
                      </div>


                    </div>
                  </div>


                  <div className="col-12 col-md-4">

                    <div className="bidding-column">
                      <div className="row">
                        <div className="col-12">
                        


                           <div className="rank-info text-end p-2" >
                          <span className="rank-label">My Rank:</span>
                          <span className="rank-value">{auction.my_rank} {!auction.my_rank && "N/A"}</span>
                        </div>

                          {/* Amount Grid */}
                          <div className="amount-grid-modern pt-2">

                            <div className="amount-card-modern">
                              <div className="amount-label-modern">{i18n.t("bid_counr")}</div>
                              <div className="amount-value-modern">
                                #{auction.bid_count}
                              </div>
                            </div>

                            <div className="amount-card-modern">
                              <div className="amount-label-modern">{i18n.t("start_amount")}</div>
                              <div className="amount-value-modern">
                                {formatCurrency(auction.start_amount)} <SaudiRiyalLogo />
                              </div>
                            </div>

                            {/* <div className="amount-card-modern">
                                    <div className="amount-label-modern">{i18n.t("start_bid_amount")}</div>
                                    <div className="amount-value-modern">
                                        {formatCurrency(auction.start_amount)} <SaudiRiyalLogo/>
                                    </div>
                                </div> */}
                            <div className="amount-card-modern">
                              <div className="amount-label-modern">{amount_label}</div>
                              <div className="amount-value-modern">
                                {formatCurrency(auction.current_amount)} <SaudiRiyalLogo />
                              </div>
                            </div>


                            <div className="amount-card-modern">
                              <div className="amount-label-modern">{i18n.t("gurantee_amount")}</div>
                              <div className="amount-value-modern">
                                {formatCurrency(guarantee_amount)} <SaudiRiyalLogo />
                              </div>
                            </div>


                            {/* <div className="amount-card-modern">
                                    <div className="amount-label-modern">{i18n.t("vat")}</div>
                                    <div className="amount-value-modern">{auction.vat || "0"}%</div>
                                </div> */}
                          </div>



                          {/* Visit Amount Section */}
                          {Number(auction.visit_amount) > 0 && (
                            <div className="visit-section-modern">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>
                                    {i18n.t("visit_amount")}: {formatCurrency(auction.visit_amount)} <SaudiRiyalLogo />
                                  </strong>
                                </div>
                                {auction.is_visit_active && (
                                  <VisitNow
                                    amount={auction.visit_amount}
                                    type="sitevisit"
                                    id={auction.id}
                                    gid={auction.group}
                                    is_group={false}
                                    group={auction.group}
                                    main_class="btn btn-warning-custom btn-sm"
                                  />
                                )}
                              </div>
                            </div>
                          )}

                          {/* Date Section */}
                          {/* <div className="amount-grid-modern">
                                <div className="date-section-modern">

                                    <div className="date-item-modern">
                                        <div className="amount-label-modern">{i18n.t("start_date")}</div>
                                        <div className="date-value">
                                            {startDateAr && startDateAr["date"] ? startDateAr["date"] : ""}
                                        </div>
                                        <div className="date-text">({start_time})</div>
                                        <div className="date-text">
                                            {startDateAr && startDateAr["day"] ? i18n.t(startDateAr["day"]) : ""}
                                        </div>
                                    </div>

                                </div>
                                <div className="date-section-modern">


                                    <div className="date-item-modern">
                                        <div className="amount-label-modern">{i18n.t("end_date")}</div>
                                        <div className="date-value">
                                            {endDateAr && endDateAr["date"] ? endDateAr["date"] : ""}
                                        </div>
                                        <div className="date-text">({end_time})</div>
                                        <div className="date-text">{auction.days_remaining} {i18n.t("days_of_auction")}</div>
                                    </div>
                                </div>
                            </div> */}



                          {/* Action Buttons */}


                        </div>


                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* Additional Information Footer */}
              {/* <div className="card-footer-horizontal">
                <div className="footer-info">
                  <span className="guarantee-amount">
                    {i18n.t("gurantee_amount")}: {formatCurrency(guarantee_amount)} <SaudiRiyalLogo/>
                  </span>
                  <span className="days-remaining">
                    <i className="fa fa-calendar me-2"></i>
                    {auction.days_remaining} {i18n.t("days_of_auction")}
                  </span>
                </div>

           
                {auction.status === "A" && !auction.is_bid_time_ends && auction.end_date && can_show_end_clock && (
                  <div className="countdown-section">
                    <Countdown
                      date={aucEndTime}
                      renderer={rendererEnds}
                      onComplete={() => {
                        this.setState({ bidTimeStopped: true });
                      }}
                      now={() => new Date(auction.server_time)}
                    />
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>

        <BiddingModal
          open_popup={this.state.open_popup}
          closeModal={this.closeModal}
          auction={auction}
          lng={current_lng}
          key={key}
        />
      </React.Fragment>
    );
  }
}